/**
 * Default timezone for date/time search values.
 */
export const DEFAULT_SEARCH_VALUE_TIMEZONE = 'America/New_York';

/**
 * Polling interval (in milliseconds) for refreshing trip counts.
 */
export const TRIP_COUNTS_POLL_INTERVAL_MS = 5 * 60 * 1000;
